import { Component, Input } from '@angular/core';

@Component({
    selector: 'rwidget-empty-state',
    templateUrl: './empty-state.component.html'
})

export class EmptyStateComponent {
    @Input() title = '';
    @Input() description = '';
    @Input() icon = 'emptyState';
}
